
/**
 *      Data-driven UI logic for date formatting and search date filter
 *
 *      @autor Irina Patrikeeva <irina.i.patrikeeva@nasa.gov>
 *
 *      Created by on 09/26/2017
 *      Modified on 08/01/2018
 */

/**
 * Get milliseconds in one day
 */
function dayInMilliseconds( ) {
    return 24 * 60 * 60 * 1000;
}

/**
 * Get milliseconds in one month (30 days)
 */
function monthInMilliseconds( ) {
    return 30 * dayInMilliseconds();
}

/**
 * Get milliseconds in one year (365 days)
 */
function yearInMilliseconds( ) {
    return 365 * dayInMilliseconds();
}

/**
 * Returns a string representing date with time if time is non zero. Zero time is not included for clarity.
 * Use UTC time getters because JavaScript date is based on a time value that is milliseconds since midnight 01 January, 1970 UTC.
 * Otherwise, some dates are off by a day, i.e. input "1990-12-01" without UTC will output "11/30/1990"
 * @param value {string} - string representation of a date, e.g. "2015-09-12T18:14:33.705Z"
 * @return {string}
 *
 * Examples:
 * input "2015-09-12" outputs "09/12/2015"
 * input "2015-09-12 00:00:00.000" outputs "09/12/2015"
 * input "2015-09-12 18:14:33.705Z" outputs "09/12/2015 (18:14:33:705)"
 * input "2015-09-12T00:00:00.000Z" outputs "09/12/2015"
 * input "2015-09-12T18:14:33.705Z" outputs "09/12/2015 (18:14:33:705)"
 * input 2015/09/12" outputs "09/12/2015"
 * input "2015/09/12 00:00:00:000" outputs "2015/09/12"
 * input "2015/09/12T00:00:00:000" outputs "2015/09/12T00:00:00:000"
 * ***/
function formatDate(value) {
    var date,
        dateString,
        month,
        day,
        hours,
        minutes,
        seconds,
        milliseconds;

    if (!value) {
        return '';
    }
    // Strip any HTML tags
    value = sanitizeAll(value);

    // If input is a number then, return a Date representation of that number (milliseconds)
    if (typeof value === "number") {
        date = new Date(value);
    }
    else if (value.indexOf(' ') !== -1) {
        date = new Date(value.replace(' ', 'T'));
    } else {
        date = new Date(value);
    }

    //Our failsafe -- if we don't get a valid date, we'll just return what we were passed
    if (isNaN(date.getDate())) {
        return value;
    }

    // Add leading zero(s) to month and days
    month = date.getUTCMonth() + 1;
    if (month < 10) {
        month = '0' + month.toString();
    }

    day = date.getUTCDate();
    if (day < 10) {
        day = '0' + day.toString();
    }

    dateString = month + '/' + day + '/' + date.getUTCFullYear();

    // Add leading zero(s) to time
    hours = date.getUTCHours();
    if (hours < 10) {
        hours = '0' + hours.toString();
    }
    minutes = date.getUTCMinutes();
    if (minutes < 10) {
        minutes = '0' + minutes.toString();
    }
    seconds = date.getUTCSeconds();
    if (seconds < 10) {
        seconds = '0' + seconds.toString();
    }
    milliseconds = date.getUTCMilliseconds();
    if (milliseconds < 10) {
        milliseconds = '00' + milliseconds.toString();
    } else if (milliseconds < 100) {
        milliseconds = '0' + milliseconds.toString();
    }

    // Add non-empty time string to dateString
    if (date.getUTCHours() > 0 || date.getUTCMinutes() > 0 || date.getUTCHours() > 0 || date.getUTCSeconds() > 0 || date.getUTCMilliseconds() > 0) {
        dateString += ' (' + hours + ':' + minutes + ':' + seconds + ':' + milliseconds + ')';
    }

    return dateString;
}

/**
 * Filter search results by date
 * @param parentId {string} - DOM ID of the select element
 * @param value {string} - selected value of the filter
 */
function filterSearchResultsByDate( parentId, value ) {
    var field,
        fieldValue;

    if ( parentId && value ) {

        $( parentId + ' option' ).each( function() {
            if ( value === DateFilterKeys.all ) {
                removeDateFilter( true );
            }
            else if ( $(this).val() === value ) { // this check is needed to avoid multiple calls from date select element

                field = "indexed";
                fieldValue = getDateValue( value );

                if ( fieldValue ) {

                    // Check if global date filter is defined
                    if ( App.globalState.dateFilter === "all" ) {

                        App.globalState.dateFilter = value;

                        addFilter( field, field.capitalizeFirstLetter(), fieldValue.toISOString(), formatDate(fieldValue.toISOString()), "gt", FieldTypes.date );

                    }
                    else {
                        App.globalState.dateFilter = value;
                        updateDateFilter( fieldValue.toISOString() );
                    }
                }

            }
        });
    }
}

/**
 * Add filter from available filters menu to global filters collection
 * @param value {string} - filter value (i.e. "all")
 */
function addDateFilter( value ) {
    var filter,
        add = true;


    // Check if indexed field already exists in the global store

    filter = new FilterModel();
    filter.set( "field", "indexed" );
    filter.set( "label", "Indexed" );

    if ( value ) {
        var filterValue = getDateValue(value);
        if ( filterValue ) {
            var stringValue = filterValue.toISOString();
            filter.set( "value", stringValue );
            filter.set( "displayValue", formatDate( stringValue ) );
            filter.set( "operator", "gt" );
            filter.set( "type", FieldTypes.date );

            if ( App && App.globalState && App.globalState.currentFilters ) {
                _.each( App.globalState.currentFilters.models, function ( filter ) {
                    if ( filter.get( "field" ) === "indexed" ) {
                        add = false;
                    }
                });

                if ( add ) {

                    App.globalState.currentFilters.add( filter );

                } else {
                    console.log("Error: Cannot add a second indexed filter to the global filters store");
                }
            }
        }
    }
}

/**
 * Update date filter value in the URL and redirect
 * @param value {string} - date value as an ISO string
 */
function updateDateFilter( value ) {

    var URLFilters = getFiltersStringFromURL();

    if ( URLFilters ) {
        // find indexed filter
        // var indexedArray = URLFilters.split("indexed|gt|");
        var oldValue = getDateFilterValueFromURL();
    }

    updateEndURL( value, oldValue, true );

}

/**
 * Remove global date filter for indexed field, and reset date filter to default
 * @param trigger {boolean} - signals whether to trigger a redirect
 */
function removeDateFilter( trigger ) {
    var filters,
        previous;

    // If global filters currently contain an "indexed" field, remove it
    App.globalState.dateFilter = DateFilterKeys.all;
    filters = App.globalState.currentFilters;
    if ( filters.models.length > 0 ) {
        previous = filters.findWhere( { field: "indexed" } );
        if ( previous ) {
            removeFilter( previous.get( "field" ), previous.get( "value" ), trigger );
        }
    }
}

/**
 * Convert a JavaScript Date object into a string literal
 * @param value {Date | string} - Date object
 * @returns {*} - null if Date is not one of the DateFilterKeys
 */
function getDateFilterString( value ) {

    var result = null,
        diff,
        inputDateFull = new Date(value),
        oneDay = dayInMilliseconds(), // one day in milliseconds
        oneMonth = monthInMilliseconds(), // one month in milliseconds
        oneYear = yearInMilliseconds(), // one year in milliseconds

        // Compare input date with date filter values
        year = inputDateFull.getFullYear(),
        month = inputDateFull.getMonth(),
        day = inputDateFull.getDate(),

        // Create new date objects for input date and for today's date
        inputDate = new Date(year, month, day),
        todayFull = new Date(),
        today = new Date( todayFull.getFullYear(), todayFull.getMonth(), todayFull.getDate() );

        // Set hours to midnight on both dates

        inputDate.setUTCHours(0,0,0,0);
        today.setUTCHours(0,0,0,0);

        // Convert both dates to milliseconds since January 1, 1970
        var inputTime = Number( inputDate.getTime() );
        var todayTime = Number( today.getTime() );

        // Compare two times and calculate the difference
        diff = Math.abs( todayTime - inputTime );

    if ( diff === oneDay ) {
        result = DateFilterKeys.today;
    } else if ( diff === oneDay * 2 ) {
        result = DateFilterKeys.yesterday;
    } else if ( diff === oneDay * 8 ) {
        result = DateFilterKeys.week;
    } else if ( diff === oneDay * 31 ) {
        result = DateFilterKeys.month;
    } else if ( diff === oneDay * 91 ) {
        result = DateFilterKeys.ninetyDays;
    } else if ( diff === oneMonth * 6 ) {
        result = DateFilterKeys.sixMonths;
    }
    else if ( diff === oneYear ) {
        result = DateFilterKeys.year;
    }
    else {
        result = DateFilterKeys.all;
    }

    return result;
}

/**
 * Get the display value for date type filter
 * Set the date search filter value if it is an indexed field
 * Format fields of enumeration type that have options
 * @param filterModel {BackboneModel} - filter model to display
 * @returns {*}
 */
function getDisplayValueForDate( filterModel ) {
    var displayValue,
        value,
        filterField;

    if ( filterModel ) {
        filterField = filterModel.get("field");
        value = filterModel.get("value");
        if ( filterField === "indexed" ) {

            // Set the date filter drop-down in the search results summary

            displayValue = getDateFilterString( value );
            App.globalState.dateFilter = displayValue;

            $( '#date-filter' ).val( displayValue );
            displayValue = DateFilter[ App.globalState.dateFilter ];
        } else {
            displayValue = formatDate( value );
        }
    }
    return displayValue;
}

/**
 * Convert a string literal into a JavaScript Date object
 * @param value {string} - English word that says how far back in time to look
 * @returns result {*} - Date object or null if input is invalid
 */
function getDateValue( value ) {
    var result = null,
        today = new Date(),
        diff,
        milliseconds = 0,
        oneDay = dayInMilliseconds(); // one day in milliseconds
    switch ( value ) {
        case DateFilterKeys.today:
            // Today means in the last 24 hours
            milliseconds = oneDay;
            break;
        case DateFilterKeys.yesterday:
            // Yesterday means in the last 48 hours
            milliseconds = oneDay * 2;
            break;
        case DateFilterKeys.week:
            // One week means in the last 7 days
            milliseconds = 8 * oneDay; // seven days
            break;
        case DateFilterKeys.month:
            milliseconds = 31 * oneDay; // 30 days
            break;
        case DateFilterKeys.ninetyDays:
            milliseconds = 91 * oneDay; // 90 days
            break;
        case DateFilterKeys.sixMonths:
            milliseconds = monthInMilliseconds() * 6; // 6 months
            break;
        case DateFilterKeys.year:
            milliseconds = yearInMilliseconds(); // 1 year
            break;
    }

    diff = today.getTime() - milliseconds;
    if ( diff > 0 ) {
        result = new Date( diff );
    }
    return result;
}

/**
 * Add date filter to the global store and display current and available filters
 * @param value {string} - URL filters string
 * @param response {object} - ES response object
 */
function addDateFilterFromURL( value, response ) {
    var valueArray,
        filterValue,
        filterArray,
        field,
        predicate,
        date,
        filterModel,
        fieldValue;

    if ( value ) {
        valueArray = value.split(';');
        if ( valueArray && valueArray.length > 0 ) {
            filterValue = valueArray[ 0 ];
            if ( filterValue ) {
                filterArray = filterValue.split('|');
                if ( filterArray && filterArray.length === 3 ) {

                    field = filterArray[ 0 ];
                    predicate = filterArray[ 1 ];
                    date = filterArray[ 2 ];

                    filterModel = new BackboneModel;
                    filterModel.set("field", field);
                    filterModel.set("value", date);
                    filterModel.set("type", "date");

                    fieldValue =  getDisplayValueForDate( filterModel );
                    if ( fieldValue ) {
                        // Add the filter to the global store
                        addFilterToGlobal( field, field.capitalizeFirstLetter(), date, DateFilter[ fieldValue ], predicate, "date" );
                    }

                    displayCurrentFilters();
                    displayInitialDataTypes( response );
                }
            }
        }
    }
}

/**
 * Check global date filter setting
 * @returns {boolean} - flag that indicates if date filter is set
 */
function isGlobalDateFilterSet() {
    var result = false,
        value = App.globalState.dateFilter;

    if ( value && value !== "all") {
        result = true;
    }
    return result;
}

/**
 * Add date filter to the URL
 * @param trigger {boolean} - flag to trigger the redirect
 */
function addDateFilterToURL( trigger ) {

    var current,
        urlArray,
        value,
        oldUrl,
        newUrl;

    if ( isGlobalDateFilterSet() ) {
        // Check if URL already contains an indexed filter
        current = Backbone.history.getFragment();

        if ( current ) {
            urlArray = current.split( '&filters=' );
            if ( ! ( urlArray && urlArray.length === 2 ) ) {
                // Add new filters URL string with indexed field
                value = getDateValue( App.globalState.dateFilter );

                if ( value ) {
                    oldUrl = current;
                    newUrl = oldUrl + "&filters=indexed:gt:" + value;
                    updateEndURL( oldUrl, newUrl, trigger );
                }
            }
        }
    }
}